module.exports = __webpack_public_path__ + "static/media/aggregates-on-sand-mobile.2803a912.jpg";